import React, { useEffect, useState } from "react";
import { Typography } from "@mhome/ui";
import { Lock, LockOpen, LockClock } from "@mui/icons-material";

const LockDetail1Widget = ({ widget, onValueUpdate, pattern }) => {
  const [status, setStatus] = useState(null);
  const [widgetData, setWidgetData] = useState(null);

  useEffect(() => {
    if (!widget) return;
    setWidgetData(widget);

    if (widget.items?.$w1) {
      const currentValue = widget.items.$w1.value;
      setStatus(
        currentValue === "" || currentValue === null ? "unknown" : currentValue
      );
    }
  }, [widget]);

  const getStatusText = () => {
    if (!status) return "unknown";
    return status;
  };

  const isUnlocked = () => {
    return status === "unlocked" || status === "not fully locked";
  };

  const getStatusIcon = () => {
    switch (status) {
      case "locked":
        return <Lock style={{ fontSize: "1.5rem" }} />;
      case "unlocked":
        return <LockOpen style={{ fontSize: "1.5rem" }} />;
      case "not fully locked":
        return <LockClock style={{ fontSize: "1.5rem" }} />;
      default:
        return <Lock style={{ fontSize: "1.5rem" }} />;
    }
  };

  const handleCommand = (command) => {
    if (pattern && pattern.endsWith("_R")) return;
    if (!widgetData?.items?.$w2) return;

    const updatedWidget = {
      ...widgetData.items.$w2,
      value: command,
    };
    onValueUpdate(updatedWidget);
  };

  const disabled = pattern && pattern.endsWith("_R");
  const hasControl = !!widgetData?.items?.$w2;

  return (
    <div className="w-full flex flex-col gap-4">
      {/* Lock Status Card */}
      <div
        className="rounded-2xl px-3 py-1.5 flex items-center justify-between transition-colors duration-300"
        style={{
          height: "60px",
          backgroundColor: "hsl(var(--card))",
          border: isUnlocked() ? `2px solid hsl(var(--primary))` : "none",
        }}
      >
        <Typography className="font-bold capitalize">
          Lock status: {getStatusText()}
        </Typography>
        <div className="h-10 aspect-square flex items-center justify-center flex-shrink-0">
          {getStatusIcon()}
        </div>
      </div>

      {/* Lock Controls */}
      {hasControl && (
        <div
          className="flex flex-col gap-3 p-4 rounded-2xl"
          style={{
            backgroundColor: "hsl(var(--card))",
          }}
        >
          <Typography className="font-bold">Lock Controls</Typography>

          <div className="flex justify-center gap-4">
            <button
              onClick={() => !disabled && handleCommand("lock")}
              disabled={disabled}
              className="flex flex-col items-center justify-center flex-1 px-4 rounded-lg transition-all duration-200 hover:scale-105 active:scale-95 shadow-none"
              style={{
                paddingTop: "10px",
                paddingBottom: "10px",
                paddingLeft: "1rem",
                paddingRight: "1rem",
                backgroundColor: "hsl(var(--primary))",
                color: "hsl(var(--primary-foreground))",
                border: "none",
                cursor: disabled ? "not-allowed" : "pointer",
                opacity: disabled ? 0.5 : 1,
              }}
              onMouseEnter={(e) => {
                if (!disabled) {
                  e.currentTarget.style.backgroundColor = "hsl(var(--primary))";
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "hsl(var(--primary))";
              }}
            >
              <div className="mb-2">
                <Lock style={{ fontSize: "1.5rem" }} />
              </div>
              <Typography className="text-xs">Lock</Typography>
            </button>

            <button
              onClick={() => !disabled && handleCommand("unlock")}
              disabled={disabled}
              className="flex flex-col items-center justify-center flex-1 px-4 rounded-lg transition-all duration-200 hover:scale-105 active:scale-95 shadow-none"
              style={{
                paddingTop: "10px",
                paddingBottom: "10px",
                paddingLeft: "1rem",
                paddingRight: "1rem",
                backgroundColor: "hsl(var(--primary))",
                color: "hsl(var(--primary-foreground))",
                border: "none",
                cursor: disabled ? "not-allowed" : "pointer",
                opacity: disabled ? 0.5 : 1,
              }}
              onMouseEnter={(e) => {
                if (!disabled) {
                  e.currentTarget.style.backgroundColor = "hsl(var(--primary))";
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "hsl(var(--primary))";
              }}
            >
              <div className="mb-2">
                <LockOpen style={{ fontSize: "1.5rem" }} />
              </div>
              <Typography className="text-xs">Unlock</Typography>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LockDetail1Widget;
